export default "__VITE_ASSET__qmJQO9Xz__"